import { useMutation } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { baseUrl } from '@/data/subsidy/base';
import type { RefundableRequestByResource } from '@/data/subsidy/interfaces';

interface RefundableAmountByResourceResponse {
  refundable_amount: string;
  policy_refund_limit: string | null;
}

interface RefundableAmountByResourceRequest {
  resourceApprovalRequest: RefundableRequestByResource;
  policyUuid: string;
}

export const useRefundableAmountByResource = () => {
  return useMutation({
    mutationFn: async ({
      resourceApprovalRequest,
      policyUuid,
    }: RefundableAmountByResourceRequest): Promise<RefundableAmountByResourceResponse> => {
      return (await falconClient.post(
        `${baseUrl}/policies/${policyUuid}/refundable-amount-by-resource`,
        resourceApprovalRequest
      )) as unknown as RefundableAmountByResourceResponse;
    },
  });
};
